import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { RequestStatus } from 'legacy/lut/configs/service'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Nullable } from 'cng-common/models/utils'
import {
  changeAssortmentSidePanelCollapsedState,
  changeSelectedCategory,
} from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentCategory } from 'partner360/features/assortment/models/data/IAssortmentCategory'
import {
  selectAssortmentIsCollapse,
  selectAssortmentSelectedCategory,
  selectAssortmentSettingsCategories,
  selectAssortmentSettingsCategoriesStatus,
} from 'partner360/features/assortment/selectors'
import { requestAssortmentCategories } from 'partner360/features/assortment/thunks'

interface IParams {
  partnerId: string
  programType: ProgramTypes
  fYear: number
}

export const useAssortmentSideBar = ({ partnerId, programType, fYear }: IParams) => {
  const dispatch = useAppDispatch()

  const isCollapsed = useSelector(selectAssortmentIsCollapse)
  const loadingStatus = useSelector(selectAssortmentSettingsCategoriesStatus)
  const categories = useSelector(selectAssortmentSettingsCategories)
  const selectedCategory = useSelector(selectAssortmentSelectedCategory)

  const isLoading = useMemo(() => loadingStatus === RequestStatus.PENDING, [loadingStatus])

  const toggleAssortmentSideBar = useCallback(() => {
    dispatch(changeAssortmentSidePanelCollapsedState())
  }, [dispatch])

  const getAssortmentItems = useCallback(() => {
    dispatch(
      requestAssortmentCategories({
        programType,
        partnerId,
        fYear,
      })
    )
  }, [programType, partnerId, fYear, dispatch])

  const setSelectedCategory = useCallback(
    (newItem: Nullable<IAssortmentCategory>) => {
      dispatch(changeSelectedCategory(newItem))
    },
    [dispatch]
  )

  return {
    isCollapsed,
    isLoading,
    categories,
    selectedCategory,
    getAssortmentItems,
    setSelectedCategory,
    toggleAssortmentSideBar,
  }
}
